import { Injectable } from '@angular/core';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    getUserForms(page: any): any {
        return this.http.get(this.common.apiServiceURL + 'Forms/getUserForms?page=' + page + '&emailAddress=' + this.authentication.userData.eMail);
    }

    getFormByCode(code: any) {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Forms/getFormByCode?code=' + code, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    isUserRegisterd(formCode: any, userId: any) {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Forms/isUserRegistered?userId=' + userId + '&formCode=' + formCode, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    submitForm(data: any) {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Forms/submitForm', data, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });

    }
}
